import styled from 'styled-components';

import Input from '../Input';
import { defaultThemeProp } from '../../theme';

const StyledCurrencyInput = styled(Input)`
  /* Numbers are written left-to-right even in RTL languages. */
  direction: ltr;
  :dir(rtl) {
    text-align: right;
  }
`;

StyledCurrencyInput.defaultProps = defaultThemeProp;

export default StyledCurrencyInput;
